import 'isomorphic-fetch';

import { PRECACHE_DATA } from '../Precache/constants';
import { actionWith } from '../../utils/redux';

function preloadImage(sources) {
  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const element = new Image();
      element.onload = () => resolve(element);
      element.onerror = () => reject(src);
      element.src = src;
    });
  };

  const promises = sources.map(src => loadImage(src));

  return Promise.all(promises);
}

export default function precacheMiddleware(req) {
  return store => dispatch => action => {
    if (!action) {
      return dispatch(action);
    }

    if (action.type === PRECACHE_DATA) {
      dispatch(actionWith(action, 'SEND'));

      if (action.mediaType === 'image') {
        return preloadImage(action.data)
          .then(() => dispatch(actionWith(action, 'SUCCESS')));
      }
    }

    return dispatch(action);
  };
}



// WEBPACK FOOTER //
// ./src/redux/middleware/precache.js